<template>
  <el-container>
    <el-container style="padding: 20px 40px; width: 100%;">
      <el-header>
        <el-steps :active="activestep" finish-status="success" simple style="margin-top: 20px">
          <el-step title="基本信息" icon="el-icon-edit"></el-step>
          <el-step title="负责人信息" icon="el-icon-edit"></el-step>
        </el-steps>
      </el-header>
      <el-main>
        <UpCusOne :hidden="ro_one" @regtwo="regtwo"></UpCusOne>
        <UpCusTwo :hidden="ro_two" @showsh="showsh"></UpCusTwo>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import UpCusOne from './UpCusOne'
  import UpCusTwo from './UpCusTwo'
  var that
  export default {
    name: 'UpCus',
    components: {UpCusOne,UpCusTwo},
    data () {
      return {
        activestep: 1,
        dactive: 1,
        ro_one: false,
        ro_two: true
      }
    },
    mounted () {
      document.title = '密码重置'
      that = this
      window.console.log(that)
      that.activestep = parseInt(localStorage.getItem('regcustep'))
      if (that.activestep === '' || that.activestep === 0 || localStorage.getItem('regcustep') === null) {
        that.activestep = 1
      }
      switch (that.activestep) {
        case 1:
          that.ro_one = false
          that.ro_two = true
          break;
        case 2:
          that.ro_one = true
          that.ro_two = false
          break;
      }
    },
    methods:{
      regtwo () {
        that.ro_one = true
        that.ro_two = false
        that.activestep = 2
      },
      showsh () {
        that.$emit('showsh',0)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/UpCus.vue